import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
import { TimeOfDayLegend } from "./TimeOfDayLegend";
import { TimeOfDayHeatmapColumn } from "./TimeOfDayHeatmapColumn";
export const TimeOfDayStatsPanel = ({ options, title = "Non-conformities by time of the day", }) => {
    const [loading, setLoading] = useState(false);
    const [industryData, setIndustryData] = useState([]);
    const industryMaxFleet = useMemo(() => Math.max(...industryData.map((x) => x.Fleet), 0), [industryData]);
    const industryMaxIndustry = useMemo(() => Math.max(...industryData.map((x) => x.Industry), 0), [industryData]);
    useEffect(() => {
        if (!options.isReady)
            return;
        setIndustryData([]);
        setLoading(true);
        const params = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            fleets: options.fleet.map((f) => f.ID).join(","),
            vesselTypes: options.vesselTypes.join(","),
        });
        fetch(`/api/benchmark/timeofdaystat?${params.toString()}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((stats) => {
            setIndustryData(stats);
        })
            .catch(() => {
            notifyError("An error has occurred when loading non-conformities by time of day. Please try again.");
        })
            .finally(() => {
            setLoading(false);
        });
    }, [
        options.isReady,
        options.startDate,
        options.endDate,
        options.vesselTypes.join(","),
        options.fleet.map((fleet) => fleet.ID).join(","),
    ]);
    return (_jsx(BenchmarkCard, { title: title, children: loading ? (_jsx(WkoLoadingSpinner, {})) : industryData.length === 0 ? (_jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) })) : (_jsxs("div", { className: "w-100", children: [_jsx("div", { className: "mb-1", children: "Data from your fleet" }), _jsx("div", { className: "d-flex flex-wrap row g-0", children: industryData.map((data) => (_jsx(TimeOfDayHeatmapColumn, { index: data.Index, topValue: data.Fleet, topMaxValue: industryMaxFleet, bottomValue: data.Industry, bottomMaxValue: industryMaxIndustry }, data.Index))) }), _jsx("div", { className: "mb-1", children: "Industry Average" }), _jsx(TimeOfDayLegend, { children: "Darker colours indicate greater frequency of NCs during that time of the day" })] })) }));
};
